import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild, AfterViewInit, AfterContentChecked, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { DomEventService } from 'src/app/common/dom-event/dom-event.service';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import {TranslateService} from '@ngx-translate/core';
import  {Constant}  from '../../../constants/constants';
import { CoxService } from 'src/app/app-business-object-module/cox.service';
import { FormService } from '../../services/form.service';
import { Modal } from 'src/app/common/modal/modal';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';
import { APP_Constants } from 'src/app/app.constant';
@Component({
    selector: 'app-form-field-dropdown-default-v2',
    templateUrl: './form-field-dropdown-default-v2.component.html',
    styleUrls: ['./form-field-dropdown-default-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldDropdownDefaultV2Component implements OnInit, AfterViewInit, AfterContentChecked, OnDestroy  {


  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;
  enum=Constant;
  focusedOption: number = -1;
  placeHolderText = "";
  values: any = [];
  data = {};
  dropIsClosed = true;
  selectedOpt: any;
  sortAsc = true;
  checkboxAllStatus = false;
  showDropSelect = false;
  disabled: boolean = false;
  typableDropdownOptions: any = [];
  clickedInsideComponent: boolean = false;
  selectedItems = [];
  validationType: string = '';
  PreferredUom:any;

  clickEventSubscription: Subscription;
  keyDownEventSubscription: Subscription;

  @ViewChild('dropdown',{static: true, read: ElementRef}) dropdown: ElementRef;
  @ViewChild('dropdownselect',{static: true, read: ElementRef}) dropdownselect: ElementRef;
  @ViewChild('dropselect',{static: true, read: ElementRef}) dropselect: ElementRef;
  @ViewChild('droplabel',{static: false, read: ElementRef}) droplabel: ElementRef;
  @ViewChild('dropIcon',{static: true, read: ElementRef}) dropIcon: ElementRef;
  @ViewChild('options',{static: true, read: ElementRef}) options: ElementRef;
  @ViewChild('dropdownouter',{static: true, read: ElementRef}) dropdownouter: ElementRef;
  @ViewChild('sortIcon',{static: true, read: ElementRef}) sortIcon: ElementRef;
  @ViewChild('select',{static: true, read: ElementRef}) select: ElementRef;
  @ViewChild('typableinput',{static: true, read: ElementRef}) typableinput: ElementRef;
  @ViewChild('nomatch',{static: true, read: ElementRef}) nomatch: ElementRef;
  orderFormSubmitted: any;
  orderForm: any;
  editField: boolean;
  isLoading: boolean;
  templateData: any;
  modalService: any;
  selfServiceConfig: boolean = false;
  constructor(private renderer: Renderer2, private appService: AppService, private domEventService: DomEventService, public translate: TranslateService, private coxService :CoxService, private formService : FormService) {
  }

  isClickInsideComponent(element, classname) {
    if (element && element.className && element.className.split(' ').indexOf(classname)>=0 && element.id == this.configData.name) return true;
    return element.parentNode && this.isClickInsideComponent(element.parentNode, classname);
  }

  ngOnInit() {
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    if(this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);
    this.disabled = this.configData.disabled;
    if (this.configData['editable'] === false) {
      this.disabled=true;
      console.log("this.disable",this.disabled)
    }
    if (this.configData.disabled) {
      this.frmGroup.get(this.configData.name)['required'] = false;
      this.configData.required = false;
    }

    //this.renderer.listen('window', 'click', (e: Event) => {
      this.clickEventSubscription = this.domEventService.click.subscribe((e: MouseEvent) => {
      this.clickedInsideComponent = this.isClickInsideComponent(e.target, 'dhl-dropdown');
      if (!this.clickedInsideComponent || ((this.dropselect && e.target !== this.dropselect.nativeElement) && (this.droplabel && e.target !== this.droplabel.nativeElement) &&
        e.target !== this.dropdown.nativeElement && e.target !== this.dropdownselect.nativeElement &&
        e.target !== this.options.nativeElement && e.target !== this.dropIcon.nativeElement &&
        e.target !== this.dropdownouter.nativeElement && (this.sortIcon && e.target !== this.sortIcon.nativeElement))) {
        this.focusout();
      }
    });

    this.keyDownEventSubscription = this.domEventService.keyDown.subscribe((e: KeyboardEvent) => this.onKeyDown(e));

    this.placeHolderText = this.configData.placeHolder || this.configData.placeholder;
    //this.data = JSON.parse(JSON.stringify(this.configData.placeholder)); // commented by 750776, as this variable doesnot seem to be used anywhere and is throwing error while parsing.
  }


 /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }
  sendToSource(event, data = {} ) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: this.frmGroup.get(this.configData.name).value
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  fieldValueValidation(validations){
    validations.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
      //required error message for freight class for tms, acme training and HDI2M Customers
      // else if (element === 'Mandatory' && this.frmGroup.get(this.configData.name).value.value =='') {
      //   setTimeout(()=>{
      //     this.frmGroup.controls[this.configData.name].setErrors({"required": true});
      //   })
      // }
    });
  }
  toggleDisable(bool) {
    this.disabled = bool;
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']){
    this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    this.frmGroup.get(this.configData.name).reset();
    this.frmGroup.get(this.configData.name).updateValueAndValidity();
  }

  normalView() {
    throw new Error('Method not implemented.');
  }

  ngAfterViewInit() {
    if(Object.keys(this.frmGroup.get(this.configData.name).value).length > 0){
      this.selectedOption(this.frmGroup.get(this.configData.name).value.value, true);
    } else if (Object.keys(this.configData.defaultValue).length > 0) {
      this.selectedOption(this.configData.defaultValue.value, true);
    }

    if (this.frmGroup.get(this.configData.name).value != '') {
      this.selectedOption(this.frmGroup.get(this.configData.name).value, true);
    }

    this.frmGroup.get(this.configData.name).statusChanges.subscribe(x => {
      if (this.frmGroup.get(this.configData.name).value == undefined || this.frmGroup.get(this.configData.name).value == null) {
        this.dropdown.nativeElement.classList.remove('filled');
      } else {
        if(this.frmGroup.get(this.configData.name).status !== 'DISABLED'){
          this.dropdown.nativeElement.classList.add('filled');
          this.frmGroup.get(this.configData.name).markAsDirty();
        }
      }
    });
  }

  ngAfterContentChecked() {
    if (!this.dropIsClosed) {
      this.positionDrop();
    }
  }

  toggleDrop(target) {
    if (target && target.classList.value.indexOf('sort-icon') == -1 ||
      (target && target.classList.value.indexOf('sort-icon') > -1 && this.dropIsClosed)) {
      this.dropIsClosed = !this.dropIsClosed;
      if (this.dropIsClosed) {
        this.dropdown.nativeElement.classList.remove('focus');
        this.dropIcon.nativeElement.classList.replace('open', 'closed');
        if (this.configData.sortable) {
          this.sortIcon.nativeElement.classList.replace('default', 'filled');
        }
        if (this.selectedOpt == undefined && this.droplabel) {
          this.droplabel.nativeElement.classList.add('large');
        }
      } else {
        this.dropdown.nativeElement.classList.add('focus');
        this.dropIcon.nativeElement.classList.replace('closed', 'open');
        if (this.droplabel && this.selectedOpt) {
          this.droplabel.nativeElement.classList.remove('large');
        }
        this.dropdown.nativeElement.focus();
      }
    }
  }

  sortOptions() {
    if (this.configData.options.length > 0) {
      if (this.sortAsc) {
        this.configData.options.sort((a, b) => a.displayValue < b.displayValue ? -1 : a.displayValue > b.displayValue ? 1 : 0);
      } else {
        this.configData.options.sort((a, b) => a.displayValue > b.displayValue ? -1 : a.displayValue < b.displayValue ? 1 : 0);
      }
    }
    this.sortAsc = !this.sortAsc;
  }

  positionDrop() {
    const { top }​​​​​ = this.options.nativeElement.getBoundingClientRect();
    const virtualScrollWrapper = document.getElementById('virtual-scroll-wrapper');
    let showOnTop = false;

    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let elOffsetTop = top + scrollTop;
    let elHeight = this.options.nativeElement.offsetHeight;
    let heightOfDropdown = this.dropdownouter.nativeElement.offsetHeight;
    let mainContentAreaPaddingBottom = 24; //document.getElementsByClassName('main-content-area').style.paddingBottom;

    if (virtualScrollWrapper) {
      const virtualScrollWrapperTop = virtualScrollWrapper.getBoundingClientRect().top;
      const virtualScrollWrapperHeight = virtualScrollWrapper.clientHeight;
      showOnTop = ((top - virtualScrollWrapperTop) + 150) > virtualScrollWrapperHeight;
    } else {
      showOnTop = (window.innerHeight - mainContentAreaPaddingBottom) < elOffsetTop + elHeight;
    }

    if(showOnTop){​​​​​
      this.options.nativeElement.classList.add('ulta');
      this.options.nativeElement.style.top = (7-elHeight) + "px";
      this.options.nativeElement.style.width = this.dropdownouter.nativeElement.offsetWidth + "px";
    }​​​​​else{​​​​​
      this.options.nativeElement.classList.remove('ulta');
      this.options.nativeElement.style.top = (heightOfDropdown-7) + "px";
      this.options.nativeElement.style.width = this.dropdownouter.nativeElement.offsetWidth + "px";
    }​​​​​

  }

  focusout(forced?: boolean) {
    if(!this.clickedInsideComponent || forced){
      this.dropIsClosed = true;
      this.dropdown.nativeElement.classList.remove('focus');
      this.dropIcon.nativeElement.classList.replace('open', 'closed');
    }
    if (this.configData.sortable) {
      if (this.selectedOpt !== undefined) {
        this.sortIcon.nativeElement.classList.replace('focused', 'default');
      } else {
        this.sortIcon.nativeElement.classList.replace('focused', 'filled');
      }
    }
    this.dropdown.nativeElement.classList.remove('tab-focus');
    if(forced){
      this.frmGroup.get(this.configData.name).markAsTouched();
    }
  }

  focusin() {
    if (this.dropdown && this.options && this.options.nativeElement.classList.value.indexOf('hide') > -1) {
      this.dropdown.nativeElement.classList.add('tab-focus');
    }
  }

  selectedOption(selOpt, selectDefault) {
    if((selOpt == "" || selOpt == null) && !selectDefault){
      this.reset(selOpt, selectDefault);
    }else{
      if(selectDefault){
        let obj = this.configData.options.find((o) => {
            if (o.value && selOpt && String(o.value).toUpperCase() === String(selOpt).toUpperCase()) {
                return true; // stop searching
            }
        });
        if(obj){
          this.selectedOption(obj, false);
        }
        // else{
        //   this.reset(selOpt, selectDefault);
        // }
      }else{
        this.selectedOpt = selOpt;
        this.configData.placeholder = this.selectedOpt.displayValue;
        this.configData.placeHolder = this.selectedOpt.displayValue;
        this.dropdown.nativeElement.classList.add('filled');
        if(this.droplabel){
          this.droplabel.nativeElement.classList.remove('large');
        }
        for(let i=0;i<this.configData.options.length;i++){
          this.configData.options[i]['selected'] = false;
        }
        this.selectedOpt['selected'] = true;
        this.showDropSelect = true;
        this.frmGroup.get(this.configData.name).setValue(this.selectedOpt.value);

        // this.focusout();
        this.toggleDrop(null);
        this.manageAffectedColumn(selOpt);
      }
    }
    if (this.frmGroup.get(this.configData.name).valid && this.configData.events) {
      if(this.configData.events[0].action == 'TEMPLATE_CHANGE')
        {
          let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'TEMPLATE_CHANGE') ;
          if (event) {
            this.sendToSource(event, null);
            return
          }
        }else{
        let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'SELECTED_VALUE');
        if (event) {
          this.sendToSource(event, null);
          return
        }
      }
    }
    //Form Group validation services
    this.formService.groupValidationSrv(this.configData, this.frmGroup);
  }

  manageAffectedColumn(data) {
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'CHANGE');
    if (event) {
      this.sendToSource(event, data);
      return
    }
    if (this.configData['affectedColumns']) {
      this.configData['affectedColumns'].forEach(element => {
        let multipleValue;
        let multipleKey;
        if(element.multipleValue && element.multipleKey){
          multipleValue = element.multipleValue;
          multipleKey = element.multipleKey;
        } else {
          multipleValue = element.value;
          multipleKey = element.key;
        }
        if (element.type == "pattern") {
          if (multipleKey === data.value) {
            multipleValue.forEach(field => {
              if (!field.keepValue) {
                this.frmGroup.get(field.name).updateValueAndValidity();
              }
            });
          }
        } else if (element.setDefaultTime) {
          multipleValue.forEach(field => {
            let comp = this.appService._components[field.name];
            if (this.frmGroup.get(this.configData.name).value == multipleKey && comp) {
              this.frmGroup.get(field.name).setValue("00");
              this.frmGroup.get(field.name).updateValueAndValidity();
              comp.disabled = true;
              comp.configData.placeHolder = this.frmGroup.get(field.name).value;
            } else if(comp) {
              comp.disabled = false;
            }
          })
        } else if (multipleKey === data.value || (Array.isArray(multipleKey) && multipleKey.indexOf(data.value) !== -1)) {
          multipleValue.forEach(field => {
            let fieldName = (typeof field == 'object' ? field.name : field);
            this.frmGroup.get(fieldName)['hidden'] = false;
            this.frmGroup.get(fieldName)['required'] = field.required ?? true;
            if (this.frmGroup.get(fieldName)['required']) {
              this.frmGroup.get(fieldName).setValidators([Validators.required]);
            }
            this.frmGroup.get(fieldName).updateValueAndValidity();
          })
        } else {
          multipleValue.forEach(field => {
            let fieldName = (typeof field == 'object' ? field.name : field);
            this.frmGroup.get(fieldName)['hidden'] = true;
            this.frmGroup.get(fieldName)['required'] = field.required ?? false;
            this.frmGroup.get(fieldName).setValidators(null);
            this.frmGroup.get(fieldName).updateValueAndValidity();
            if (!field.keepValue) {
              this.frmGroup.get(fieldName).reset("");
            }
          })
        }
      });
    }
  }

  //@HostListener("window:keydown", ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.dropdown.nativeElement.classList.value.indexOf('tab-focus') > -1
      || this.dropdown.nativeElement.classList.value.indexOf('focus') > -1) {
      const optionsOuter = this.options.nativeElement;
      const options = optionsOuter.children[0].children;
      if (event.key == 'ArrowDown' && this.options.nativeElement.classList.value.indexOf('hide') > -1) {
        this.toggleDrop(event.target);
      } else if (event.key == 'ArrowDown') {
        if (this.focusedOption > -1 && options.length > 0 && this.focusedOption < options.length) {
          options[this.focusedOption].classList.remove('hover')
        }
        this.focusedOption += 1;
        if (this.focusedOption >= options.length) {
          this.focusedOption = options.length - 1;
        }
        if (this.focusedOption < options.length) {
          options[this.focusedOption].classList.add('hover');
          options[this.focusedOption].scrollIntoView({ behavior: "smooth", inline: "nearest" });
        }
      }
      if (event.key == 'ArrowUp' && this.options.nativeElement.classList.value.indexOf('hide') == -1) {
        if (this.focusedOption > 0) {
          options[this.focusedOption].classList.remove('hover')
        }
        this.focusedOption -= 1;
        if (this.focusedOption <= 0) {
          this.focusedOption = 0;
        }
        if (this.focusedOption < options.length && this.focusedOption > -1) {
          options[this.focusedOption].classList.add('hover');
          options[this.focusedOption].scrollIntoView({ behavior: "smooth", inline: "nearest" });
        }
      }
      if (event.key == 'Enter' && this.options.nativeElement.classList.value.indexOf('hide') == -1) {
        this.selectedOption( this.configData.options[this.focusedOption], false);
      }
      if (event.key == 'Tab') {
        this.focusout(true);
      }
    }
  }

  setValueToControl(value){
    if (value == "" && Object.keys(this.configData.defaultValue).length > 0) {
      this.selectedOption(this.configData.defaultValue.value, true);
    }else{
      let obj = this.configData.options.find((o) => {
        if (o.value && value && String(o.value).toUpperCase() === String(value).toUpperCase()) {
            return true; // stop searching
        }
      });
      if(obj){
        this.selectedOption(obj, false);
      }else{
        this.selectedOption(value, false);
      }
    }
  }

  makeRequiredFields(required){
    this.configData.required = required;
    // if(!required){
    //   this.selectedOption('', false);
    // }
    // return this.frmGroup.get(this.configData.name)

  }

  reset(selOpt, selectDefault){
    if((this.configData.defaultValue['value']) != '' && typeof (this.configData.defaultValue['value']) !== 'undefined'){
      this.selectedOption(this.configData.defaultValue.value, true);
      this.frmGroup.get(this.configData.name).markAsDirty();
    } else if ((this.frmGroup.get(this.configData.name)['value']) != '' && typeof (this.frmGroup.get(this.configData.name)['value']) !== 'undefined') {
      this.selectedOption(this.frmGroup.get(this.configData.name).value, true);
      this.frmGroup.get(this.configData.name).markAsDirty();
    }
    else {
      this.frmGroup.get(this.configData.name).setValue("");
      this.configData.placeholder = "";
      this.configData.placeHolder = "";
      this.showDropSelect = false;
      this.dropdown.nativeElement.classList.remove('filled');
      if (this.droplabel) {
        this.droplabel.nativeElement.classList.add('large');
      }
      this.frmGroup.get(this.configData.name).markAsPristine();
    }
  }

  ngOnDestroy() {
    if (this.clickEventSubscription)
      this.clickEventSubscription.unsubscribe();
    if (this.keyDownEventSubscription)
      this.keyDownEventSubscription.unsubscribe();
  }
}
